import UAParser from 'ua-parser-js'

const queryString = window.location.search

// Ahora usamos URLSearchParams normalmente
const urlParams = new URLSearchParams(queryString);

export const getDefaultVariables = () => {

    const parser = new UAParser()
    const uaData = {
        device: parser.getDevice(),
        os: parser.getOS(),
        engine: parser.getEngine(),
        browser: parser.getBrowser(),
    }

    const geoData = getGeoData()

    const variables = {
        utm_medium: urlParams.get('utm_medium'),
        utm_source: urlParams.get('utm_source'),
        utm_campaign: urlParams.get('utm_campaign'),
        utm_content: urlParams.get('utm_content'),
        utm_id: urlParams.get('utm_id'),
        utm_term: urlParams.get('utm_term'),

        device_type: uaData.device?.type ?? "desktop",

        os_name: uaData.os?.name,
        os_version: uaData.os?.version,

        browser_name: uaData.browser?.name,
        browser_version: uaData.browser?.version,

        location_host: window.location.host,
        location_href: window.location.href,

        country: geoData?.country || 'no_data',
        continent: geoData?.continent || 'no_data',
        region: geoData?.region || 'no_data',
        city: geoData?.city || 'no_data',
        currency: geoData?.currency || 'no_data',
        timezone_gmt: geoData?.timezone_gmt || 'no_data',
        isp: geoData?.isp || 'no_data'
    }

    if (urlParams && urlParams.get('product')) {
        variables.product = urlParams.get('product')
    }

    if (urlParams && urlParams.get('options')) {
        variables.options = urlParams.get('options')
    }

    if (urlParams && urlParams.get('origin')) {
        variables.origin = urlParams.get('origin')
    }

    if (urlParams && urlParams.get('trace_id')) {
        variables.trace_id = urlParams.get('trace_id')
    }

    





    return Object.entries(variables)
        .map(([label, value]) => (
            {
                label: label,
                value: value ?? '',
            }
        ))
}

export const getUserIdFromUrl = () => {
    return urlParams.get('user') ? urlParams.get('user').replace(/ /g, '+') : urlParams.get('user')
    
}

const getGeoData = () => {
    const request = new XMLHttpRequest()

    try {
        
        request.open('GET', 'https://ipwhois.pro/json/?key=e10hswmPhWTdBJdQ', false)
        request.send(null)
    
        if (request.status === 200) {
            try{
                return JSON.parse(request.responseText)
            }catch (e) {
                console.log(e)
                return {}
            }
        } else {
            return "no_data"
        }
    } catch (error) {
        return "no_data"
    }
}


// WEBPACK FOOTER //
// ./src/helpers/metadata.js